import React, { useMemo } from "react";
import { useData, ADMIN_TABLE } from "../../context/DataContext";
import { cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";

export default function PendingTasksAdmin() {
  const { adminRecords, loading } = useData();

  // Filter to show ALL master tasks that are pending (Not Started / In Progress only)
  const pending = useMemo(() =>
    adminRecords.filter((r) => {
      const s = cellText(r.fields?.["Overall Status"]).toLowerCase();
      const isDone = s.includes("done") || s.includes("✅") || s.includes("complet");
      const isOverdue = s.includes("overdue") || s.includes("🔴");
      const isPending = s.includes("not started") || s.includes("⬜") || s.includes("progress") || s.includes("🟡") || s === "";
      return isPending && !isDone && !isOverdue;
    }),
    [adminRecords]
  );

  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading tasks...</span></div>;

  return (
    <div className="fade-in">
      <TaskTable
        title="⏳ Pending Overall Tasks"
        tableId={ADMIN_TABLE}
        records={pending}
        emptyMsg="No pending master tasks found."
        canEdit={true}
        canDelete={true}
        statusOptionsOverride={["⬜ Not Started", "🟡 In Progress"]}
        sortDueAsc
      />
    </div>
  );
}
